interface AssembleMailContentParams {
    // The user's message (editor content, placeholder already stripped)
    body: string;
    // The (possibly per-mail edited) signature HTML, or '' when there is none
    signatureHtml: string;
    // The forwarded thread HTML, or '' for a new mail / reply
    forwardedHtml: string;
}

// Single source of truth for the sent HTML. The editor only ever holds the
// user's message; the signature and the forwarded thread live outside it and
// are re-joined here, in the order message → signature → forwarded (Outlook
// style), mirroring the mobile compose flow.
const assembleMailContent = ({
    body,
    signatureHtml,
    forwardedHtml,
}: AssembleMailContentParams): string =>
    [
        body || "<p></p>",
        signatureHtml ? `<br />${signatureHtml}` : "",
        forwardedHtml || "",
    ].join("");

export default assembleMailContent;
